import React, { useReducer } from 'react';

export const AdminContext = React.createContext();

const initialStatus = {
  isAdmin: false,
  campaignId: null,
};

const AdminReducer = (state, action) => {
  switch (action.type) {
    case 'set_admin':
      return {
        ...state,
        isAdmin: action.isAdmin,
        campaignId: action.campaignId,
      };

    case 'reset_state':
      return initialStatus;

    default:
      return state;
  }
};

export const AdminProvider = (props) => {
  const [state, dispatch] = useReducer(AdminReducer, initialStatus);

  return (
    <AdminContext.Provider value={[state, dispatch]}>
      {props.children}
    </AdminContext.Provider>
  );
};
